var __await = this && this.__await || function (v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
};
var __asyncGenerator = this && this.__asyncGenerator || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator)
        throw new TypeError('Symbol.asyncIterator is not defined.');
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb('next'), verb('throw'), verb('return'), i[Symbol.asyncIterator] = function () {
        return this;
    }, i;
    function verb(n) {
        if (g[n])
            i[n] = function (v) {
                return new Promise(function (a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume('next', value);
    }
    function reject(value) {
        resume('throw', value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length)
            resume(q[0][0], q[0][1]);
    }
};
var __asyncValues = this && this.__asyncValues || function (o) {
    if (!Symbol.asyncIterator)
        throw new TypeError('Symbol.asyncIterator is not defined.');
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === 'function' ? __values(o) : o[Symbol.iterator](), i = {}, verb('next'), verb('throw'), verb('return'), i[Symbol.asyncIterator] = function () {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function (v) {
            return new Promise(function (resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function (v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var __asyncDelegator = this && this.__asyncDelegator || function (o) {
    var i, p;
    return i = {}, verb('next'), verb('throw', function (e) {
        throw e;
    }), verb('return'), i[Symbol.iterator] = function () {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function (v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === 'return'
            } : f ? f(v) : v;
        } : f;
    }
};
import {
    Guid,
    isGuidAccepted
} from '@ef-carbon/primitive';
import linkPossibles from '../link/possibles';
function isIterable(o) {
    return o !== null && typeof o === 'object' && typeof o[Symbol.iterator] === 'function';
}
export class FormationWalkOptions {
    constructor(options) {
        this.maximum = undefined;
        this.end = undefined;
        this.skip = new Set();
        if (typeof options === 'number') {
            this.maximum = options;
        } else if (isGuidAccepted(options)) {
            this.end = `${ new Guid(options) }`;
        } else if (isIterable(options)) {
            this.skip = new Set(Array.from(options, i => `${ new Guid(i) }`));
        } else if (typeof options === 'object' && options !== null) {
            const {maximum, end, skip} = options;
            if (end) {
                this.end = `${ new Guid(end) }`;
            }
            if (skip) {
                this.skip = new Set(Array.from(skip, i => `${ new Guid(i) }`));
            }
            if (maximum) {
                this.maximum = typeof maximum === 'number' ? maximum : parseInt(`${ maximum }`, 10);
            }
        } else {
            throw new TypeError(`Invalid walk options: ${ JSON.stringify(options) }`);
        }
        if (this.maximum !== undefined && (this.maximum < 0 || isNaN(this.maximum))) {
            throw new TypeError(`Invalid formation walk maximum: ${ this.maximum }`);
        }
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.maximum.configurable = false;
        descriptors.end.configurable = false;
        descriptors.skip.configurable = false;
        Object.defineProperties(this, descriptors);
    }
}
function traverse(cache, current, maximum, end, skip, seen) {
    return __asyncGenerator(this, arguments, function* traverse_1() {
        const id = `${ current.id }`;
        const max = maximum || 256;
        if (seen.has(id) || seen.size >= max) {
            return yield __await(undefined);
        }
        seen.add(id);
        if (!skip.has(id)) {
            yield yield __await(current);
        }
        let iterators = [];
        for (const guids = linkPossibles(current.link); guids.size || iterators.length;) {
            if (seen.size >= max) {
                return yield __await(undefined);
            }
            if (guids.size) {
                const guid = guids[Symbol.iterator]().next().value;
                guids.delete(guid);
                const next = yield __await(traverse(cache, yield __await(cache.fetch(guid)), maximum, end, skip, seen));
                iterators.push(next);
            }
            for (let i = iterators.length - 1; i >= 0; --i) {
                const iterator = iterators[i];
                if (!iterator) {
                    throw new Error(`Processed an 'undefined' iterator`);
                }
                const {
                    done,
                    value: formation
                } = yield __await(iterator.next());
                if (done) {
                    iterators[i] = undefined;
                    continue;
                }
                yield yield __await(formation);
                if (end && end === `${ formation.id }`) {
                    return yield __await(undefined);
                }
            }
            iterators = iterators.filter(i => i !== undefined);
        }
    });
}
export function formationWalk(cache, current, options = {}) {
    return __asyncGenerator(this, arguments, function* formationWalk_1() {
        const config = new FormationWalkOptions(options);
        yield __await(yield* __asyncDelegator(__asyncValues(traverse(cache, current, config.maximum, config.end, config.skip, new Set()))));
    });
}
export {
    formationWalk as walk,
    FormationWalkOptions as Options
};
export default formationWalk;    //# sourceMappingURL=walk.js.map
